import { fetchApi } from "./fetchApi";

export default {
  async list() {
    const response = await fetchApi({
      method: "get",
      url: "/api/permission",
    });

    return response.data.result;
  },
};
